<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import SimpleLayout from "@/layouts/simple/SimpleLayout.vue";
import EmailPassword from "supertokens-web-js/recipe/emailpassword";
import logoImage from "@/assets/images/BeePallet_Logo_Black.png";
import { showErrorAlert, showSuccessAlert } from "@/helpers/SweetAlertHelper";

const route = useRoute();
const router = useRouter();

const password = ref("");
const repeatPassword = ref("");
const showMatchError = ref(false);
const showPassError = ref(false);
const isSubmitting = ref(false);
const token = ref(route.query.token as string);

onMounted(() => {
  if (!token.value) {
    showErrorAlert("El enlace de recuperación es inválido o ha expirado.");
    router.push("/forgot-password");
  }
});

const handleResetPassword = async () => {
  showMatchError.value = false;
  showPassError.value = false;

  // Validate password length & structure
  const passwordRegex = /^(?=.*\d).{8,}$/;
  if (!passwordRegex.test(password.value)) {
    showPassError.value = true;
    return;
  }

  if (password.value !== repeatPassword.value) {
    showMatchError.value = true;
    return;
  }

  isSubmitting.value = true;

  try {
    const response = await EmailPassword.submitNewPassword({
      method: "token",
      formFields: [{ id: "password", value: password.value }],
      token: token.value,
    });

    if (response.status === "OK") {
      showSuccessAlert("", "Contraseña restablecida con éxito. Redirigiendo al login...");
      router.push({name: "login"});
    } else {
      showErrorAlert("El enlace ha expirado o es inválido.");
      router.push({name: "login"});
    }
  } catch (error) {
    showErrorAlert("Error al restablecer la contraseña.");
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <SimpleLayout>
    <template #content>
      <div class="login-page">
        <div class="login-container">
          <router-link to="home">
            <img :src="logoImage" class="beepallet-logo" alt="Logo de BeePallet">
          </router-link>
          <form class="login-form" @submit.prevent="handleResetPassword">
            <div class="input_container">
              <label class="input_label" for="password">Contraseña</label>
              <input type="password" id="password" class="input-field is-placeholder" v-model="password" required />
              <p v-if="showPassError" class="password-error">Debe contener al menos 8 caracteres e incluir un número.</p>
            </div>
            <div class="input_container">
              <label class="input_label" for="repeatPassword">Repetir Contraseña</label>
              <input type="password" id="repeatPassword" class="input-field is-placeholder" v-model="repeatPassword" required />
              <p v-if="showMatchError" class="password-error">Las contraseñas no coinciden.</p>
            </div>
            <button type="submit" class="btn-primary-green" :disabled="isSubmitting">
              Restablecer contraseña
            </button>
          </form>
        </div>
      </div>
    </template>
  </SimpleLayout>
</template>

<style scoped lang="scss">
@import 'ResetPasswordPage';

.password-error {
  color: red;
  font-size: 0.9rem;
  margin-top: 5px;
}
</style>